import { useCallback, useState } from 'react';
const searchLearnContent = (searchQuery, learnContent, isGBUser) => {
    if (!learnContent || !searchQuery) {
        return null;
    }
    const lowerCaseSearchQuery = searchQuery.toLowerCase();
    const resultArticles = new Map();
    const resultVideos = new Map();
    Object.keys(learnContent).forEach((category) => {
        if (!isGBUser &&
            (category === 'borrow' ||
                category === 'invest' ||
                category === 'save')) {
            return;
        }
        Object.keys(learnContent[category]).forEach((contentType) => {
            const typedContentType = contentType;
            if (typedContentType !== 'showWalkthrough') {
                learnContent[category][typedContentType].forEach((content) => {
                    if ('headline' in content &&
                        content.headline.toLowerCase().includes(lowerCaseSearchQuery)) {
                        resultArticles.set(content.headline, content);
                    }
                    if ('name' in content &&
                        content.name.toLowerCase().includes(lowerCaseSearchQuery)) {
                        resultVideos.set(content.name, content);
                    }
                });
            }
        });
    });
    return {
        articles: [...resultArticles.values()],
        videos: [...resultVideos.values()],
    };
};
export const useSearchFieldLearn = (initialSearchTerm = '', setFilteredResults, learnContent, isGBUser) => {
    const [searchTerm, setSearchTerm] = useState(initialSearchTerm);
    const [isSearching, setIsSearching] = useState(false);
    const changeSearchTerm = useCallback((searchTerm) => {
        setSearchTerm(searchTerm);
        if (!isSearching && searchTerm !== '') {
            setIsSearching(true);
        }
        setFilteredResults(searchLearnContent(searchTerm, learnContent, isGBUser));
        setIsSearching(false);
    }, [isGBUser, isSearching, learnContent, setFilteredResults]);
    const cancelSearch = useCallback(() => {
        setSearchTerm('');
        setIsSearching(false);
    }, []);
    return {
        searchTerm,
        changeSearchTerm,
        cancelSearch,
        isSearching,
    };
};
